import packageInfo from '../../package.json';

export class EnvironmentConfig {
  get version(): string {
    return packageInfo.version;
  }
}
